<template>
  <div id="content">
    <form>
      <div class="step-contenair codegen">
        <h2>Générateur de codes</h2>
      
        <i style="margin-top:70px; margin-bottom:20px;">Attention, les codes ne sont pas enregistrés. Vous êtes responsable de les transmettre au client et à l'équipe de dev.</i>
        <br>
      <div class="elem">
        <label for="nbcodes">Nombre de codes*</label>
        <input
          type="number"
          id="nbcodes"
          name="Nombre de code"
          v-model.number="form.nbcodes"
          required
        />
        <div class="error">{{ errors.first("Nombre de code") }}</div>
      </div>
      <br />
      <div class="elem">
        <label for="characters">Charactères autorisés*</label>
        <input
          type="text"
          id="characters"
          name="Charactères"
          v-model="form.characters"
          required
        />
        <div class="error">{{ errors.first("Charactères") }}</div>
      </div>
      <div class="elem">
        <label for="prefix">Préfixe (en plus de la longueur)</label>
        <input
          type="text"
          id="prefix"
          name="préfixe"
          v-model="form.codePrefix"
          placeholder="(ex: PROMO_ )"
        />
        <div class="error">{{ errors.first("préfixe") }}</div>
      </div>
      <br />
      <div class="elem">
        <label for="codeLength">Longueur des codes*</label>
        <input
          type="number"
          id="codeLength"
          name="Longueurs des codes"
          v-model.number="form.codeLength"
          required
        />
        <div class="error">{{ errors.first("Longueurs des codes") }}</div>
      </div>
      <br />
      <span class="obl">* Champs obligatoires</span>
      <br />

      <div class="form-end">
        <div class="progress-bar-container" v-if="this.progress > 0">
        <div class="progress-bar">
          <div class="progress" :style="`width:${progressP}%`"></div>
        </div>
        <div class="progress-text">{{progressP}}% - {{progress}}/{{progressObjective}}</div>
      </div>
        <button v-else class="btn-blue" v-on:click="generate()">
          <i class="fa fa-save"></i> Générer
        </button>
      </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import { saveAs } from 'file-saver';

function makeid(length, characters, lastChar) {
  let result = '';
  const charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
    let newChar = characters.charAt(Math.floor(Math.random() * charactersLength));
    if(newChar == lastChar) {
      i--; // on refait un tour de boucle
    }else {
      result += newChar;
      lastChar = newChar;
    }
  }
  return result;
}

function timeoutPromise(duration) {
  return new Promise((resolve, reject)=> {
    setTimeout(resolve, duration);
  })
}


export default {
  name: "wetransfer",
  components: {},
  created() {},
  computed: {
    filtered() {
      var filtered = this.links;
      return filtered;
    },
  },
  data: function() {
    return {
      progress: 0,
      progressObjective: 1,
      form: {
        nbcodes: 100,
        characters: "ACEFJPRWXY3459",
        codeLength: 10,
        codePrefix: undefined,
      },
    };
  },
  mounted() {},
  computed: {
    progressP() {
      return Math.round(this.progress / this.progressObjective * 100);
    }
  },
  methods: {
    async generateCodes(prefix, nbcodes, length, lastChar) {
      console.log("generateCodes", prefix, lastChar, nbcodes, length)
      let codes = [];
      while (codes.length < nbcodes) {
        let id = makeid(length, this.form.characters, lastChar);
        if(prefix && prefix.length > 0) {
          id = prefix + id;
        }
        if(!codes.includes(id)) {
          codes.push(id);
        }
        if((this.codes.length + codes.length) % (Math.ceil(this.form.nbcodes / 50)) == 0) {
          await timeoutPromise(50);
          console.log("waited", this.codes.length + codes.length, "codes");
          this.progress = this.codes.length + codes.length;
        }
      }
      return codes;
    },
    async generate() {
      event.preventDefault();

      this.$validator.validateAll().then(async (valid) => {
        if (valid) {
          this.progressObjective = this.form.nbcodes;
          this.progress = 1;
          await Vue.nextTick();
          setTimeout(async ()=>{
            try {
              this.codes = []
              const nbCodesPerChar = Math.floor(this.form.nbcodes / this.form.characters.length);

              for (let i = 0; i < this.form.characters.length; i++) {
                const char = this.form.characters[i];
                let newCodes = await this.generateCodes(char, nbCodesPerChar, this.form.codeLength-1, char);
                for (let nci = 0; nci < newCodes.length; nci++) {
                  this.codes.push(newCodes[nci]); 
                }
              }
              while (this.codes.length < this.form.nbcodes) {
                let id = makeid(this.form.codeLength, this.form.characters);
                if(this.form.codePrefix && this.form.codePrefix.length > 0) {
                  id = this.form.codePrefix + id;
                }
                if(!this.codes.includes(id)) {
                  this.codes.push(id);
                }
                if(this.codes.length % (Math.ceil(this.form.nbcodes / 50)) == 0) {
                  await timeoutPromise(50);
                  console.log("waited", this.codes.length, "codes");
                  this.progress = this.codes.length;
                }
              }
            console.log("Generated ", this.codes.length, "codes");
            const blob = new Blob([this.codes.join("\r\n")], {type: "text/plain;charset=utf-8"});
            saveAs(blob, "codes.txt");

            this.progress = 0;
          } catch (error) {
            console.log(error);
          }
          }, 200)

        }
      });
    },
  },
};
</script>
<style lang="scss">
  .progress-bar {
    height: 8px;
    background: #fafafa;
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.08);
    .progress {
      height: 100%;
      background: linear-gradient(
        110deg,
        #11998e,
        #38ef7d
      );
    }
  }
  .progress-text {
    text-align: center;
  }

</style>